<template>
  <div class="c-pb-form" v-if="ready">
    <message type="error" v-if="validationFailed">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <!-- PROPERTIES -->
    <section class="c-pb-form__props" v-if="el.properties">
      <fieldset>
        <!-- <legend>Element Properties</legend> -->
        <div v-for="propConfig in elementConfig.properties">
          <!-- Text Props -->
          <form-field
            full-width
            v-if="propConfig.type === 'text'"
            :label="propConfig.label"
            v-model="el.properties[propConfig.name]"
            v-validate="{ required: propConfig.required || false }"
            :data-vv-as="propConfig.label"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            :error="errors.first(propConfig.name)"
          ></form-field>

          <form-field
            full-width
            v-if="propConfig.type === 'textarea'"
            :label="propConfig.label"
            v-model="el.properties[propConfig.name]"
            v-validate="{ required: propConfig.required || false }"
            :data-vv-as="propConfig.label"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            :error="errors.first(propConfig.name)"
            type="textarea"
          ></form-field>

          <!-- URL Props -->
          <form-field
            full-width
            v-if="propConfig.type === 'url'"
            :label="propConfig.label"
            v-model="el.properties[propConfig.name]"
            v-validate="{
              required: propConfig.required,
              url: { require_protocol: true } || false,
            }"
            :data-vv-as="propConfig.label"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            :error="errors.first(propConfig.name)"
          ></form-field>

          <!-- Checkbox props -->
          <div
            class="c-pb-form__bool-prop-wrap"
            v-if="propConfig.type === 'checkbox'"
          >
            <input
              type="checkbox"
              :id="propConfig.name"
              :name="propConfig.name"
              v-model="el.properties[propConfig.name]"
            />
            <label :for="propConfig.name">{{ " " + propConfig.label }}</label>
          </div>

          <!-- File props -->
          <form-field
            v-if="propConfig.type === 'file'"
            :label="propConfig.label"
            :name="propConfig.name"
            v-model="el.properties[propConfig.name]"
            v-validate="{ required: propConfig.required || false }"
          >
            <file-upload
              name="document_file"
              @uploaded="onFileUploaded"
              @uploadError="handleUploadError"
              resource="content"
              :fileId="el.properties[propConfig.name]"
              :bypassDuplicate="false"
              :fileTypes="propConfig.file_types"
              :docType="{ plural: 'content', single: 'content' }"
            ></file-upload>
          </form-field>

          <form-field
            full-width
            v-if="propConfig.type === 'select'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            :error="errors.first(propConfig.name)"
            v-model="el.properties[propConfig.name]"
            v-validate="{ required: propConfig.required || false }"
          >
            <select
              class="c-form__input c-form__input--full-width"
              :name="propConfig.name"
              :id="propConfig.name"
              v-model="el.properties[propConfig.name]"
              required
              :style="
                errors.first(propConfig.name)
                  ? 'border: 1px solid #DA291C'
                  : null
              "
            >
              <!-- <option value="0" selected>Select</option> -->
              <option
                v-for="(option, key) in propConfig.options"
                :value="option.value"
                :key="key"
                >{{ option.label }}</option
              >
            </select>
          </form-field>

          <!-- radio buttons -->
          <form-field
            full-width
            v-if="propConfig.type === 'radio'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            :error="errors.first(propConfig.name)"
            v-model="el.properties[propConfig.name]"
            v-validate="{ required: propConfig.required || false }"
          >
            <label
              :for="`radio_${propConfig.name}_${key}`"
              v-for="(option, key) in propConfig.options"
              :key="key"
            >
              <input
                :id="`radio_${propConfig.name}_${key}`"
                type="radio"
                :value="option.value"
                v-model="el.properties[propConfig.name]"
              />
              {{ option.label }}
            </label>
          </form-field>

          <!--resource-selector - grab resources and put into list-->
          <form-field
            full-width
            v-if="propConfig.type === 'select-resource'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
          >
            <form-resource
              :showValidTick="false"
              include-policies
              :include-eforms="false"
              :model="el.properties[propConfig.name]"
              placeholder
              :id="propConfig.name"
              :name="propConfig.name"
              @change="onResourceChange"
            />
          </form-field>
          <form-field
            full-width
            v-if="propConfig.type === 'select-eform'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
          >
            <form-resource
              :showValidTick="false"
              :include-policies="false"
              :include-content="false"
              :include-surveys="false"
              include-eforms
            :model="el.properties[propConfig.name]"
              placeholder-text="Search for an eForm"
              :id="propConfig.name"
              :name="propConfig.name"
              @change="onResourceChange"
            />
          </form-field>
          <form-field
            full-width
            v-if="propConfig.type === 'select-survey'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
          >
            <form-resource
              :showValidTick="false"
              :include-policies="false"
              :include-content="false"
              :include-eforms="false"
              include-surveys
              :model="el.properties[propConfig.name]"
              placeholder-text="Search for a survey"
              :id="propConfig.name"
              :name="propConfig.name"
              @change="onResourceChange"
            />
          </form-field>

          <form-field
            full-width
            v-if="propConfig.type === 'select-file'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
          >
            <form-file
              :showValidTick="false"
              :model="el.properties[propConfig.name]"
              placeholder
              :id="propConfig.name"
              :name="propConfig.name"
              @change="onFileChange"
            />
          </form-field>

          <form-field
            full-width
            v-if="propConfig.type === 'select-poll'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
          >
            <form-poll
              :showValidTick="false"
              :model="el.properties[propConfig.name]"
              placeholder
              :id="propConfig.name"
              :name="propConfig.name"
              @change="onPollChange"
            />
          </form-field>

          <!--pbe-form - Select all the page elements and put into a list-->
          <form-field
            full-width
            v-if="propConfig.type === 'form-pbe'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
            :error="errors.first(propConfig.name)"
            v-validate="{ required: propConfig.required || false }"
          >
            <select
              class="c-form__input c-form__input--full-width"
              :name="propConfig.name"
              :id="propConfig.name"
              v-model="el.properties[propConfig.name]"
              :style="
                errors.first(propConfig.name)
                  ? 'border: 1px solid #DA291C'
                  : null
              "
            >
              <!-- <option value="0" selected>Select</option> -->
              <option
                v-for="(option, key) in pageBuilderElements"
                :value="option"
                :key="key"
                >{{ option.title }}</option
              >
            </select>
          </form-field>

          <form-field
            full-width
            v-if="propConfig.type === 'form-fb'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
            v-model="el.properties[propConfig.name]"
          >
            <select
              class="c-form__input c-form__input--full-width"
              :name="propConfig.name"
              :id="propConfig.name"
              v-model="el.properties[propConfig.name]"
            >
              <!-- <option value="0" selected>Select</option> -->
              <option
                v-for="(option, key) in formBuilderElements"
                :value="option"
                :key="key"
                >{{ option.title }}</option
              >
            </select>
          </form-field>

          <!--media gallery-->
          <form-field
            full-width
            v-if="propConfig.type === 'gallery'"
            :label="propConfig.label"
            :required="propConfig.required"
            :name="propConfig.name"
            :helperText="propConfig.helper_text"
          >
            <form-gallery
              @uploaded="onGalleryUpdated"
              :files="el.properties[propConfig.name] || '[]'"
              @galleryUpdated="onGalleryUpdated"
            />
          </form-field>

          <!-- wysiwyg props -->
          <div v-if="propConfig.type === 'wysiwyg'">
            <h3>{{ propConfig.label }}</h3>
            <quill-editor
              :options="quillEditorOptions"
              v-model="el.properties[propConfig.name]"
            ></quill-editor>
          </div>
          <div v-if="propConfig.type === 'hidden'">
            {{ el.properties }}
            <input
              type="text"
              :name="propConfig.name"
              v-model="el.properties[propConfig.name]"
            />
          </div>
        </div>

        <div
          class="c-pb-form__bool-props"
          v-for="(prop, key, index) in el.properties"
        >
          <!-- Text props -->
          <!-- <div class="c-pb-form__string-props" v-if="typeof prop === 'string'">
              <form-field :label="key" v-model="el.properties[key]"></form-field>
          </div>-->
        </div>
      </fieldset>
    </section>

    <!-- CONTENT - WYSIWYG -->
    <div v-if="elementConfig.content && el.hasOwnProperty('content')">
      <h3>Content</h3>
      <quill-editor
        :options="quillEditorOptions"
        v-model="el.content"
        @focus="handleQuillFocus"
        @input="handleQuillInput"
      ></quill-editor>
    </div>

    <!-- CONTENT - Text only -->
    <!-- <div>
        <form-field label="Content" :value="el.content" v-model="el.content"></form-field>
    </div>-->
    <!-- <== ACTIONS ==> -->
    <div class="c-pb-form__actions">
      <base-button :primary="true" v-if="!editMode" @click="onClickAdd"
        >Add to page</base-button
      >
      <base-button :primary="true" v-else @click="onClickUpdate"
        >Update</base-button
      >
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
// import 'quill/dist/quill.core.css'
import "quill/dist/quill.snow.css";
// import 'quill/dist/quill.bubble.css'
const FileUpload = () => import("@/components/FileUpload");
const FormFile = () => import("@/components/FormFiles");
import pageBuilderElements from "@/data/pageBuilderElements.json";
import formBuilderElements from "@/data/formBuilderElements.json";
export default {
  name: "pb-element-form",

  props: ["element", "editMode"],

  data() {
    return {
      ready: false,
      el: {},
      validationFailed: false,
      docBypass: false,

      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
          ],
          clipboard: {
            matchVisual: false,
          },
        },
        formats: ["bold", "italic", "underline", "header", "list", "link"],
      },
    };
  },

  mounted() {
    this.el = JSON.parse(JSON.stringify(this.element));
    //if we are nested within a row
    if (this.el.data && this.el.data.props) {
      this.el.properties = { ...this.el.data.props };
    }
    this.ready = true;
  },

  computed: {
    pageBuilderElements() {
      //no nesting rows please
      const doNotShow = ["base-row", "accordion-item", "media-gallery"];
      const returnData = pageBuilderElements.filter(
        (elem) => !doNotShow.includes(elem.type)
      );
      return returnData;
    },
    formBuilderElements() {
      //no nesting rows please
      const doNotShow = ["base-row", "accordion-item", "media-gallery"];
      const returnData = formBuilderElements.filter(
        (elem) => !doNotShow.includes(elem.type)
      );
      return returnData;
    },
    elementConfig() {
      const confByType = this.$store.getters["pageElements/configByType"];
      return confByType || {};
    },
    quillEdited: {
      get() {
        return this.el.content !== "Enter your content here...";
      },
      set(newVal) {
        return newVal !== "Enter your content here...";
      },
    },
  },

  methods: {
    onSurveyChange(survey) {
      this.el.properties.survey = JSON.parse(survey).id.toString();
    },
    onGalleryUpdated(data) {
      let fileIds;

      try {
        fileIds = JSON.parse(this.el.properties.fileId);
      } catch (err) {
        fileIds = [];
      }
      fileIds = data;
      this.el.properties.fileId = JSON.stringify(fileIds);
    },
    onFileUploaded(file) {
      if (this.el.type === "media-image") {
        this.el.properties.fileId = file.id;
      }

      // //when it's uploaded, get the object, mark it as selected
      if (this.el.type === "media-file") {
        this.el.properties.fileId = file.id;
      }
    },

    handleUploadError(err) {},

    handleQuillInput(res) {
      this.quillEdited = true;
    },

    handleQuillFocus(res) {
      if (!this.quillEdited) {
        res.setSelection(0, 99999);
        this.quillEdited = true;
      }
    },

    onResourceChange(resource) {
      console.log("TCL:  ~ file: PbElementForm.vue ~ line 503 ~ onResourceChange ~ this.el.type", this.el.type)
      if (["media-resource", "media-eform", "media-survey"].includes(this.el.type)) {
        const resourceObject = JSON.parse(resource) || {};
        this.el.properties.resourceLink = resource;
        this.el.properties.resourceObject = resourceObject;
        this.el.properties.title = resourceObject.name;
      }
    },

    onFileChange(resource) {
      const resourceObject = JSON.parse(resource) || {};
      this.el.properties.fileId = resourceObject.documentId;
      this.el.properties.fileLink = resource;
      this.el.properties.fileObject = resourceObject;
      if (!this.el.properties.title) {
        this.el.properties.title = resourceObject.name;
      }
    },
    onPollChange(form) {
      this.el.properties.poll = JSON.parse(form).id.toString();
    },

    onClickAdd() {
      const vm = this;

      this.$validator.validate().then((result) => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          vm.validationFailed = false;
          this.$emit("create", this.el);
        }
      });
    },

    onClickUpdate() {
      const vm = this;

      this.$validator.validate().then((result) => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          vm.validationFailed = false;
          this.$emit("update", this.el);
        }
      });
    },

    onClickRemove() {
      this.$emit("remove", this.el);
    },
  },

  components: {
    FileUpload,
    FormFile,
    "quill-editor": quillEditor,
  },
};
</script>

<style lang="scss">
.c-pb-form {
  .ql-editor {
    max-height: 400px;
  }
  .ql-editor p {
    margin-bottom: 1em;
  }
}
.c-pb-form__props {
  margin-bottom: 1em;

  fieldset {
    padding: 0;
    border: none;
  }
}
.c-pb-form__bool-props {
  margin: 1em 0;
}
.c-pb-form__string-props {
  margin: 1em 0;
}
.c-pb-form__bool-prop-wrap {
  border: 2px solid #c9ced4;
  border-radius: 4px;
  padding: 0.5em;
  margin: 1em 0;
}
.c-pb-form__actions {
  margin-top: 2em;
}
</style>
